import Amplify, { Auth } from "aws-amplify";
import { decryptCredentials } from './cifrate';

export const APP_KEY_ENCRYPT = decryptCredentials(process.env.REACT_APP_ENCRYPT_KEY_APP);

const amplifyConfig = (config, typeConfig = "SOAT") => {

  const endpointDecode = [
    {
      'name': 'API_CANAL',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_BASE_API_CANAL),
      'region': decryptCredentials(process.env.REACT_APP_AWS_REGION),
    },
    {
      'name': 'API_ONE_STEP',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_SOAT_MEMORY),
      'region': decryptCredentials(process.env.REACT_APP_AWS_REGION),
    },
    {
      'name': 'API_CANAL_AMI',
      'endpoint': decryptCredentials(process.env.REACT_APP_URL_BASE_DIGITAL_ID),
      'region': decryptCredentials(process.env.REACT_APP_AWS_REGION),
    }
  ];

  Amplify.configure({
    Auth: {
      region: decryptCredentials(process.env.REACT_APP_AWS_REGION),
      identityPoolId: decryptCredentials(process.env.REACT_APP_AWS_IDENTITY_POOL_ID),
      Storage: { region: decryptCredentials(process.env.REACT_APP_AWS_REGION) },
    },
    API: {
      endpoints: endpointDecode,
    },
    Storage: {
      region: decryptCredentials(process.env.REACT_APP_AWS_REGION),
    },
  });
  Auth.configure();

  return endpointDecode;
};

export default {
  amplifyConfig
};
